$(document).ready(function(){
  if(performance.navigation.type == 2){
   location.reload(true);
  }
  
  function macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel){
    //$('.page-macros-calculator .macrosresults-buiking').hide()
    console.log(goal);
    var weightToKG = mcWeight*0.453592;
    var heightToCM = mcHeight*2.54;
    
    if(gender == 'Male'){
      var BMR = parseInt(66+(13.7*weightToKG.toFixed(2))+(5*heightToCM.toFixed(2))-(6.8*mcYear));
    } else if(gender == 'Female'){
      var BMR = parseInt(655+(9.6*weightToKG.toFixed(2))+(1.8*heightToCM.toFixed(2))-(4.7*mcYear));
    }
    
    var tDEE = parseInt(BMR * activityLevel);
    
    if(goal == 'Cut'){
      $('.countText').text('Cutting');
      $('.count2Text').text('Cut Calories (20% reduction from TDEE)');
      var dailyFatLossCutCalories = parseInt(tDEE*0.80);      

      var fat = parseInt(dailyFatLossCutCalories*0.3/9);
      var protein = parseInt(mcWeight);
      var carbs = parseInt((dailyFatLossCutCalories-(fat*9)-(protein*4))/4);
    
    } else if(goal == 'Maintain'){
      $('.countText').text('Maintenance');
      $('.count2Text').text('Maintenance Calories (TDEE)');
      var dailyFatLossCutCalories = parseInt(tDEE);

      var fat = parseInt(dailyFatLossCutCalories*0.3/9);
      var protein = parseInt(mcWeight*1.1);
      var carbs = parseInt((dailyFatLossCutCalories-(fat*9)-(protein*4))/4);
      
    } else {
      $('.countText').text('Bulking');
      $('.count2Text').text('Bulking Calories (10% increase from TDEE)');
      var dailyFatLossCutCalories = parseInt(tDEE*1.10);

      var fat = parseInt(dailyFatLossCutCalories*0.3/9);
      var protein = parseInt(mcWeight*1.2);
      var carbs = parseInt((dailyFatLossCutCalories-(fat*9)-(protein*4))/4);
      
    }

    if(tDEE){$('.count1').text(tDEE.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))};
    if(dailyFatLossCutCalories){$('.count2').text(dailyFatLossCutCalories.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))};
    if(carbs){$('.count3').text(carbs.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))};
    if(fat){$('.count4').text(fat.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))};
    if(protein){$('.count5').text(protein.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))};
    
    /*
    var dailyFatLossCutCalories = parseInt(tDEE*0.80);
    var dailyMaintainCalories = parseInt(tDEE);
    var dailyBulkCalories = parseInt(tDEE*1.10);

    var cutFat = parseInt(dailyFatLossCutCalories*0.3/9);
    var cutProtein = parseInt(mcWeight);
    var cutCarbs = parseInt((dailyFatLossCutCalories-(cutFat*9)-(cutProtein*4))/4);
    
    var maintainFat = parseInt(dailyMaintainCalories*0.3/9);
    var maintainProtein = parseInt(mcWeight*1.1);
    var maintainCarbs = parseInt((dailyMaintainCalories-(maintainFat*9)-(maintainProtein*4))/4);
    
    var bulkFat = parseInt(dailyBulkCalories*0.3/9);
    var bulkProtein = parseInt(mcWeight*1.2);
    var bulkCarbs = parseInt((dailyBulkCalories-(bulkFat*9)-(bulkProtein*4))/4);

    var hrefButton = "/pages/macros-results?tdee="+TDEE+"&cut="+dailyFatLossCutCalories+"&carbs="+cutCarbs+"&fat="+cutFat+"&protein="+cutProtein;
    $('.mc-button a').attr('href',hrefButton);
    */
    
    //$('.page-macros-calculator .macrosresults-buiking').show();
  }
  
  var gender = $('[name="gender"]:checked').val();
  var goal = $('[name="goal"]:checked').val();
  var activityLevel = $('[name="activity-level"]:checked').attr('data-value');
  
  var mcYear = $('.mc-year .range-slider__value').text();
  var mcHeight = $('.mc-height').attr('data-height');
  var mcWeight = $('.mc-weight .weight-lbs').text();

  macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
  
  const settings = {fill: '#00C2FF',background: '#fff'}
  const sliders = document.querySelectorAll('.range-slider');
  
  Array.prototype.forEach.call(sliders,(slider)=>{
    slider.querySelector('input').addEventListener('input', (event)=>{

     var mcItem = slider.closest(".mc-item");
     if($(mcItem).hasClass('mc-year')){
       $(mcItem).find('.mc-label').find('.range-slider__value').html(event.target.value);

       mcYear = event.target.value;
       macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
     }
      
     if($(mcItem).hasClass('mc-height')){
       var heightVal = event.target.value;
       var foot = Math.floor(heightVal/12);
       var inch = heightVal % 12;
       $('.mc-height').attr('data-height',heightVal);
       mcHeight = heightVal;
       macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
       
       $(mcItem).find('.mc-label').find('.height-foot').html(foot);
       $(mcItem).find('.mc-label').find('.height-inch').html(inch);
     }
      
     if($(mcItem).hasClass('mc-weight')){
       $(mcItem).find('.mc-label').find('.weight-lbs').html(event.target.value);

       mcWeight = event.target.value;
       macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
     }
      
     applyFill(event.target);
    });
    // Don't wait for the listener, apply it now!
    applyFill(slider.querySelector('input'));
  });
  
  function applyFill(slider) {
    // Let's turn our value into a percentage to figure out how far it is in between the min and max of our input
    const percentage = 100*(slider.value-slider.min)/(slider.max-slider.min);
    // now we'll create a linear gradient that separates at the above point
    // Our background color will change here
    const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage+0.1}%)`;
    slider.style.background = bg;
  }
  
  $('.mc-gender [name="gender"]').click(function(){
    gender = $(this).val();
    macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
  });

  $('.mc-goal [name="goal"]').click(function(){
    goal = $(this).val();
    console.log(goal);
    macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
  });

  $('.mc-activity-level [name="activity-level"]').click(function(){
    activityLevel = $(this).attr('data-value');
    macros(gender,goal,mcYear,mcHeight,mcWeight,activityLevel);
  });


  $('.mc-button a').click(function(){
    $('.page-macros-calculator .macrosresults-buiking').show();
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: $('.page-macros-calculator .macrosresults-buiking').offset().top
      }, 250);
    },500);
  });
  

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };

  //=2776&cut=2220&carbs=188&fat=74&protein=200

  // var tdee = getUrlParameter('tdee');
  // var cut = getUrlParameter('cut');
  // var carbs = getUrlParameter('carbs');
  // var fat = getUrlParameter('fat');
  // var protein = getUrlParameter('protein');

  // if(tdee){$('.count1').text(tdee.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))}
  // if(cut){$('.count2').text(cut.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))}
  // if(carbs){$('.count3').text(carbs.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))}
  // if(fat){$('.count4').text(fat.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))}
  // if(protein){$('.count5').text(protein.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))}
});